'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import dayjs from 'dayjs';
import { memo, useEffect, useState } from 'react';
import { Image } from '@/components/client';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';
import styles from './WelloOnlySection.module.scss';
const WELLPOINT_LOGOS = [`${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/naver-pay.png`, `${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/kakao-pay.png`, `${WELLO_IMAGE_PREFIX_URL}/static/event/localfesta/woowa.png`];
const FIVE_MINUTES = 5 * 60 * 1000;
const Timer = memo(function Timer(t0) {
  const $ = _c(22);
  const {
    isSoldOut
  } = t0;
  const [now, setNow] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setNow(dayjs());
      const interval = setInterval(() => setNow(dayjs()), 10);
      return () => clearInterval(interval);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!now) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <p className="font-700 tabular-nums text-Gray-white typo-body2"><span className="sr-only">남은 시간</span>--분 --초 --</p>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  const hour = now.hour();
  const extraTime = isSoldOut && hour === 23 ? 3600000 : 0;
  let t3;
  if ($[3] !== now) {
    t3 = now.endOf("hour").diff(now);
    $[3] = now;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const timeRemaining = t3 + extraTime;
  const isUrgent = timeRemaining <= FIVE_MINUTES;
  const hh = Math.floor(timeRemaining / 3600000);
  const t4 = String(Math.floor(timeRemaining % 3600000 / 60000));
  let t5;
  if ($[5] !== t4) {
    t5 = t4.padStart(2, "0");
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const mm = t5;
  const t6 = String(Math.floor(timeRemaining % 60000 / 1000));
  let t7;
  if ($[7] !== t6) {
    t7 = t6.padStart(2, "0");
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const ss = t7;
  const t8 = String(Math.floor(timeRemaining % 1000 / 10));
  let t9;
  if ($[9] !== t8) {
    t9 = t8.padStart(2, "0");
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const cs = t9;
  const t10 = isSoldOut && "w-full text-center";
  const t11 = !isSoldOut && styles.timerPulse;
  const t12 = isUrgent && !isSoldOut && styles.urgent;
  let t13;
  if ($[11] !== t10 || $[12] !== t11 || $[13] !== t12) {
    t13 = cn("font-700 tabular-nums text-Gray-white typo-body2", t10, t11, t12);
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="sr-only">남은 시간</span>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const t15 = hh > 0 && `${hh}시간 `;
  let t16;
  if ($[16] !== cs || $[17] !== mm || $[18] !== ss || $[19] !== t13 || $[20] !== t15) {
    t16 = <p aria-live="polite" aria-atomic="true" className={t13}>{t14}{t15}{mm}분 {ss}초 {cs}</p>;
    $[16] = cs;
    $[17] = mm;
    $[18] = ss;
    $[19] = t13;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  return t16;
});
interface WelloOnlySectionClientProps {
  participantLimit: number;
  rewardCount: number;
}
export const WelloOnlySectionClient = t0 => {
  const $ = _c(47);
  const {
    participantLimit,
    rewardCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = dayjs().hour();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const hour = t1;
  const isSoldOut = rewardCount >= participantLimit;
  const progressPercent = participantLimit > 0 ? rewardCount / participantLimit * 100 : 0;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="rounded-xxlarge bg-O-100 px-20 py-6 shadow-md"><p className="text-center font-700 text-R-600 typo-body1">Event 1</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="font-700 tracking-wider text-O-100 typo-h7">TIME REWARD</p>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex w-full max-w-[375px] flex-col items-center gap-20">{t2}<div className="flex flex-col items-center gap-8 text-center">{t3}<div className="flex flex-col items-center"><p className="font-800 text-O-100 typo-h4">매시간 정각마다</p><p className="font-800 text-O-100 typo-h4">선착순 10,000원 당첨!</p></div></div></div>;
    t5 = cn("relative flex w-full max-w-[375px] flex-col items-center gap-28 rounded-[36px] bg-Gray-white/10 px-24 py-32 backdrop-blur-sm", styles.progressCard);
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isSoldOut) {
    t6 = <div className="flex w-full flex-col items-start">{isSoldOut ? <div className="flex w-full flex-col items-center gap-4"><p className="font-700 text-Y-550 typo-body3">{hour}시 선착순 이벤트가 종료됐어요</p><p className="font-600 text-Gray-white/80 typo-caption1">다음 시간 오픈까지</p><Timer isSoldOut={isSoldOut} /></div> : <><p className="w-full text-right font-600 text-Gray-white/80 typo-caption1">마감까지</p><div className="flex w-full items-center justify-between"><p className="font-700 text-Y-550 typo-body2">1만원 받는 중</p><Timer isSoldOut={isSoldOut} /></div></>}</div>;
    $[5] = isSoldOut;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `선착순 참여 현황: ${rewardCount}명 / ${participantLimit}명`;
  let t8;
  if ($[7] !== isSoldOut) {
    t8 = !isSoldOut && <div className="absolute inset-0 overflow-hidden"><div className={cn("absolute inset-0 bg-gradient-to-r from-transparent via-Gray-white/20 to-transparent", styles.shimmer)} /></div>;
    $[7] = isSoldOut;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = !isSoldOut && progressPercent > 0 && styles.progressGlow;
  let t10;
  if ($[9] !== t9) {
    t10 = cn("absolute left-0 top-0 h-8 rounded-xxsmall bg-Y-550", "transition-all duration-500 ease-out", t9);
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = `${isSoldOut ? 100 : progressPercent}%`;
  let t12;
  if ($[11] !== t11) {
    t12 = {
      width: t11
    };
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t10 || $[14] !== t12) {
    t13 = <div className={t10} style={t12} />;
    $[13] = t10;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== participantLimit || $[17] !== rewardCount || $[18] !== t13 || $[19] !== t7 || $[20] !== t8) {
    t14 = <div role="progressbar" aria-valuenow={rewardCount} aria-valuemin={0} aria-valuemax={participantLimit} aria-label={t7} className="absolute inset-0 overflow-hidden rounded-xxsmall bg-R-800">{t8}{t13}</div>;
    $[16] = participantLimit;
    $[17] = rewardCount;
    $[18] = t13;
    $[19] = t7;
    $[20] = t8;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== isSoldOut || $[23] !== progressPercent || $[24] !== rewardCount) {
    t15 = !isSoldOut && <div className={cn("absolute top-1/2 -translate-y-1/2 rounded-medium border-2 border-Gray-white bg-Y-550 px-8 py-2 shadow-md transition-all duration-500 ease-out", styles.badge)} style={{
      left: `max(0px, calc(${progressPercent}% - 24px))`
    }}><p className="text-center font-700 text-Gray-black typo-caption1">{rewardCount}명</p></div>;
    $[22] = isSoldOut;
    $[23] = progressPercent;
    $[24] = rewardCount;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15) {
    t16 = <div className="relative h-8 w-full">{t14}{t15}</div>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex w-full items-center justify-between font-700 text-Gray-white typo-body4"><p>0명</p><p className="text-right">???명</p></div>;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t16 || $[31] !== t6) {
    t18 = <div className="flex w-full flex-col items-start gap-8">{t6}{t16}{t17}</div>;
    $[30] = t16;
    $[31] = t6;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="flex w-full items-center justify-center rounded-small bg-Gray-white/20 px-20 py-8 backdrop-blur-sm"><div className="flex flex-col items-center text-center"><p className="font-700 text-Gray-white typo-caption1">매시간 돌아오는 선착순 혜택에 도전해보세요 👀</p><p className="font-700 text-Gray-white/90 typo-caption1">1시간마다 선착순 1만원 웰포인트를 드려요!</p></div></div>;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="underline">기부시 자동 참여</span>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <p className="text-center font-400 text-Gray-white/60 typo-caption1">본 이벤트는 {t20}되며<br />당첨 결과는 기부 완료 시점에 당첨자 대상으로만 안내됩니다.</p>;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t18) {
    t22 = <div className={t5}>{t18}{t19}{t21}</div>;
    $[36] = t18;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <h3 className="text-center font-700 text-Gray-white typo-h5">잠깐! 웰포인트가 뭔가요?</h3>;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <span className="font-700 text-Y-550">현금성 포인트</span>;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <br />;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <p className="text-center font-500 leading-relaxed text-Gray-white/90 typo-body3">웰로에서 드리는{" "}{t24}에요.{t25}네이버페이, 카카오페이, 배달의민족 등<br />다양한 쿠폰으로 교환이 가능합니다.</p>;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="flex w-full max-w-[375px] flex-col items-center gap-20 overflow-hidden rounded-[36px] bg-Gray-black/10 p-24 backdrop-blur-sm">{t23}{t26}<div className="flex items-center gap-10">{WELLPOINT_LOGOS.map(_temp)}</div></div>;
    $[42] = t27;
  } else {
    t27 = $[42];
  }
  let t28;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <p className="font-700 text-Gray-white typo-caption1">이벤트 주의사항</p>;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  let t29;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="flex w-full max-w-[375px] flex-col gap-8 px-8">{t28}<ul className="flex flex-col gap-4 font-400 text-Gray-white/70 typo-caption1"><li className="ml-18 list-disc">해당 이벤트는{" "}<span className="underline">매시간 정각마다 선착순 마감</span>됩니다.</li><li className="ml-18 list-disc">이벤트 결과는 기부 완료 시점에 당첨자 대상으로만 안내됩니다.</li><li className="ml-18 list-disc">이벤트는 기부 건 단위로 증정되므로, 다수의 기부 참여시 중복 지급될 수 있습니다.</li></ul></div>;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  let t30;
  if ($[45] !== t22) {
    t30 = <section id="wello-only" className="flex w-full scroll-mt-46 flex-col items-center gap-32 bg-R-600 px-20 py-60">{t4}{t22}{t27}{t29}</section>;
    $[45] = t22;
    $[46] = t30;
  } else {
    t30 = $[46];
  }
  return t30;
};
function _temp(logo, index) {
  return <div key={logo} className="size-55 shrink-0 overflow-hidden rounded-medium shadow-md transition-transform duration-200 hover:scale-105"><Image alt={`쿠폰 교환처 ${index + 1}`} className="size-full object-cover" width={110} height={110} src={logo} /></div>;
}